/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC */
import { withRouter, applySeo } from "../helpers"

/* Shared UI components */
import { Block } from "../components"

/* Icon component */
import Icon from "../components/Icon"

/* i18n */
import { translate } from "../translates"

const METHODS = [
    { icon: "phone", t: "Отдел продаж", v: "+7 (707) 138-51-00", href: "tel:+77071385100" },
    { icon: "phone", t: "Поддержка салонов", v: "+7 (706) 406-45-99", href: "tel:+77064064599" },
    { icon: "mail", t: "Электронная почта", v: "info@bookify.kz", href: "mailto:info@bookify.kz" }
]

const TWOGIS = "https://go.2gis.com/dhLWa"

/* Yandex expects longitude,latitude order; pt draws the marker */
const MAP_SRC = "https://yandex.ru/map-widget/v1/?ll=76.84798,43.210977&z=17&pt=76.84798,43.210977,pm2rdm"

/* Page Contacts */
class Contacts extends Component {

    componentDidMount = () => {

        /* SEO */
        applySeo({
            title: "Контакты Bookify — поддержка и связь",
            description: "Свяжитесь с командой Bookify: поддержка пользователей, вопросы по онлайн-записи и партнёрству. Телефон, email и мессенджеры.",
            path: "/contacts"
        })

        /* Scroll */
        window.scroll(0, 0)
    }

    /* Draw Methods */
    _methods = () => {
        return (
            <div className="contacts__methods">
                {METHODS.map((method) => (
                    <a key={method.t} className="contacts__method" href={method.href} target={method.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">
                        <span className="contacts__method-ic"><Icon name={method.icon} size={20} /></span>
                        <span className="contacts__method-text">
                            <small>{translate(method.t)}</small>
                            <b>{method.v}</b>
                        </span>
                        <Icon name="arrow_right" size={16} className="contacts__method-arrow" />
                    </a>
                ))}

                <div className="contacts__social-row">
                    <a className="contacts__social" href="https://instagram.com/bookify.kz" target="_blank" rel="noopener noreferrer">
                        <Icon name="image" size={18} /> Instagram
                    </a>
                    <a className="contacts__social" href="https://wa.me/77071385100" target="_blank" rel="noopener noreferrer">
                        <Icon name="phone" size={18} /> WhatsApp
                    </a>
                </div>

                <div className="contacts__legal">
                    <div className="contacts__legal-row"><span>{translate("Юр. лицо")}</span><b>{translate("ТОО «SARY GROUP»")}</b></div>
                    <div className="contacts__legal-row"><span>{translate("БИН")}</span><b>240440023071</b></div>
                    <div className="contacts__legal-row"><span>{translate("Часы работы")}</span><b>{translate("Пн–Пт · 10:00–18:00")}</b></div>
                </div>
            </div>
        )
    }

    /* Draw Map */
    _map = () => {
        return (
            <div className="contacts__map-wrap">
                <div className="contacts__map">
                    <iframe className="contacts__map-frame" title={translate("Bookify на карте — БЦ Quorum, Алматы")} src={MAP_SRC} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
                    <div className="contacts__map-bar">
                        <div>
                            <div className="contacts__map-title">{translate("БЦ Quorum, Bookify")}</div>
                            <div className="contacts__map-addr">{translate("Микрорайон Мамыр 1, 26, 508 кабинет, Алматы")}</div>
                        </div>
                        <a className="contacts__map-cta" href={TWOGIS} target="_blank" rel="noopener noreferrer">
                            <Icon name="pin" size={14} /> {translate("Открыть в 2ГИС")}
                        </a>
                    </div>
                </div>
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { navigate } = this.props

        return (
            <Block>
                <div className="page contacts">
                    <section className="section">
                        <div className="container">

                            <div className="contacts__crumbs">
                                <a onClick={() => navigate("/")}>{translate("Главная")}</a>
                                <Icon name="chevron_right" size={12} />
                                <span className="contacts__crumb-current">{translate("Контакты")}</span>
                            </div>

                            <div className="contacts__head">
                                <h1 className="about__title">{translate("Контакты")}</h1>
                                <p className="about__lede">
                                    {translate("Свяжитесь с командой Bookify любым удобным способом — мы на связи каждый день и отвечаем в течение нескольких часов.")}
                                </p>
                            </div>

                            <div className="contacts__grid">
                                {this._methods()}
                                {this._map()}
                            </div>

                        </div>
                    </section>
                </div>
            </Block>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(withRouter(Contacts))
